import { c as _c } from "react/compiler-runtime";
import ActionAddTagItem from 'modules/automation-rules/actions/components/edit-actions/components/action-add-tag-item';
import ActionCampaignItem from 'modules/automation-rules/actions/components/edit-actions/components/action-campaign-item';
import ActionCommunityItem from 'modules/automation-rules/actions/components/edit-actions/components/action-community-item';
import ActionCourseItem from 'modules/automation-rules/actions/components/edit-actions/components/action-course-item';
import ActionCreateUserItem from 'modules/automation-rules/actions/components/edit-actions/components/action-create-user-item';
import ActionEmailItem from 'modules/automation-rules/actions/components/edit-actions/components/action-email-item';
import ActionRemoveTagItem from 'modules/automation-rules/actions/components/edit-actions/components/action-remove-tag-item';
import ActionSmsItem from 'modules/automation-rules/actions/components/edit-actions/components/action-sms-item';
import ActionSpecEmailItem from 'modules/automation-rules/actions/components/edit-actions/components/action-spec-email-item';
import ActionWebhookItem from 'modules/automation-rules/actions/components/edit-actions/components/action-webhook-item';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum';
import { ActionEditType, BaseActionEditType } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import { AutomationRuleErrorInterface, AutomationRuleViewInterface } from 'modules/automation-rules/types/automation-rule-interface';
import React from 'react';
import ActionAssignPipelineStageItem from './components/action-assign-pipeline-stage-item';
import ActionCourseBundleItem from './components/action-course-bundle-item';
export interface EditActionsProps {
  actions: ActionEditType[];
  setRules: React.Dispatch<React.SetStateAction<AutomationRuleViewInterface>>;
  errors: AutomationRuleErrorInterface;
}
const EditActions = t0 => {
  const $ = _c(10);
  const {
    actions,
    setRules,
    errors
  } = t0;
  let t1;
  if ($[0] !== actions || $[1] !== setRules) {
    t1 = index => {
      setRules(prev => ({
        ...prev,
        actions: actions.filter((_, idx) => idx !== index)
      }));
    };
    $[0] = actions;
    $[1] = setRules;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onDelete = t1;
  let t2;
  if ($[3] !== actions || $[4] !== errors || $[5] !== onDelete || $[6] !== setRules) {
    t2 = actions.map((action, idx_0) => {
      const baseProps = {
        errors,
        setRules,
        onDelete,
        idx: idx_0,
        actions
      };
      switch (action.type) {
        case AutomationRuleActionsEnum.send_email:
          {
            return <ActionEmailItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.send_email_to_specific_address:
          {
            return <ActionSpecEmailItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.add_tag:
          {
            return <ActionAddTagItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.remove_tag:
          {
            return <ActionRemoveTagItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.send_webhook:
          {
            return <ActionWebhookItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.enroll_in_course:
        case AutomationRuleActionsEnum.revoke_access_to_course:
          {
            return <ActionCourseItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.subscribe_to_campaign:
        case AutomationRuleActionsEnum.unsubscribe_from_campaign:
          {
            return <ActionCampaignItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.create_user:
        case AutomationRuleActionsEnum.create_white_label_user:
          {
            return <ActionCreateUserItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.grant_access_to_community:
        case AutomationRuleActionsEnum.revoke_access_to_community:
          {
            return <ActionCommunityItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.enroll_in_course_bundle:
        case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
          {
            return <ActionCourseBundleItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.assign_to_pipeline_stage:
          {
            return <ActionAssignPipelineStageItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        case AutomationRuleActionsEnum.send_sms:
          {
            return <ActionSmsItem key={`${action.type}-${action.id}`} {...baseProps} action={action} />;
          }
        default:
          {
            return null;
          }
      }
    });
    $[3] = actions;
    $[4] = errors;
    $[5] = onDelete;
    $[6] = setRules;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <>{t2}</>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};
export default EditActions;